import {
  Lit3formBlock,
  html,
  unsafeHTML,
  classMap,
} from '@Root/lib/lit-3form-block';
import { styles } from './css';

import {
  analyticsLabelFromString,
  analyticsCtaDataObject,
} from '../../../helpers/adobe-analytics';

import '@Helpers/vimeo-video';

export class Corwin extends Lit3formBlock {
  static get characterName() {
    return 'corwin';
  }

  static get characterProperties() {
    return {
      header: { type: String },
      description: { type: String },
      cta: { type: String },
    };
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid corwin-layout">
          <div class="${classMap(this.detailsClasses)}">
            ${this.headerHTML} ${this.descriptionHTML} ${this.ctaHTML}
          </div>
          ${this.videoId
            ? html`
                <div class="video">
                  <vimeo-video videoid="${this.videoId}"></vimeo-video>
                </div>
              `
            : html`
                <div class="image">
                  <img src="${this.imageUrl}" />
                  ${this.imageDescriptionHTML}
                </div>
              `}
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  get detailsClasses() {
    const verticalAlignment = this.content.vertical_text_alignment || 'top';
    const classes = {
      details: true,
    };

    classes[`vertical-${verticalAlignment}`] = true;

    return classes;
  }

  get headerHTML() {
    return this.headerText
      ? html`
          <h2 class="header">${unsafeHTML(this.headerText)}</h2>
        `
      : ``;
  }

  get descriptionHTML() {
    return this.descriptionText
      ? html`
          <p class="description">${unsafeHTML(this.descriptionText)}</p>
        `
      : ``;
  }

  get ctaHTML() {
    return this.hasCta
      ? html`
          <cta-button
            class="cta-btn"
            cta-data=${this.ctaInfo}
            cta-type="secondary"
            .ctaAnalyticsData=${analyticsCtaDataObject(
              this.ctaInfo,
              this.headerText
            )}
          ></cta-button>
        `
      : ``;
  }

  get ctaInfo() {
    return JSON.stringify(this.content.cta);
  }

  get hasCta() {
    return this.content.cta && !!this.content.cta.text;
  }

  get headerText() {
    return this.withLineBreaks(this.content.header) || '';
  }

  get descriptionText() {
    return this.withLineBreaks(this.content.description) || '';
  }

  get videoId() {
    if (!!this.content.video_url && this.content.video_url.includes('vimeo')) {
      return this.content.video_url.match(
        /^https?:\/\/(?:.*?)\.?(vimeo)\.com\/(\d+).*$/
      )[2];
    } else {
      return '';
    }
  }

  get imageUrl() {
    return !!this.content.image
      ? this.imagebossUrl(this.content.image.src, null, 750)
      : '';
  }

  get fullResolutionImageUrl() {
    return !!this.content.image ? this.content.image.full_resolution_src : '';
  }

  get imageDescriptionHTML() {
    return !!this.imageDescription
      ? html`
          <div class="image-description">
            <span>
              <p>${unsafeHTML(this.imageDescription)}</p>
            </span>
            <span>
              <download-button
                downloadData=${JSON.stringify({
                  file_format: 'JPG',
                  file_name: analyticsLabelFromString(this.imageDescription),
                  link_url: this.fullResolutionImageUrl,
                  link_type: 'IMAGE',
                  placement: analyticsLabelFromString(this.headerText),
                })}
              >
              </download-button>
            </span>
          </div>
        `
      : html``;
  }

  get imageDescription() {
    return !!this.content.image?.description
      ? this.withLineBreaks(this.content.image.description)
      : '';
  }
}
Corwin.defineElement();
